/*
 * Title: 회원초대 서비스
 * Author: KimTaeOh (taeoh.kim@gentlepie.com )
 * Date: 2021-04-03
 * @Object: GentleServiceInviteMember
 * @Property Value
 * - sponserId: 후원인 아이디 
 * - sponserName: 후원인 이름 
 * @Property Method
 * - selectInviteType: 회원초대방식선택
 * - sponserIsMe: 나를 후원인으로 초대장 생성
 * - sponserIsOther: 다른 사람을 후원인으로 초대장 생성 
 */

import GentleWidget from '../common/widget';
import GentleUtil from '../common/util';
import GentleApi from '../common/api';
import GentleComponentButton from '../component/button';
import GentleComponentBubble from '../component/bubble';
import GentleComponentQuickReply from '../component/quickReply';
import GentleLang from '../common/lang';

var GentleServiceHelp = Object.create( GentleWidget,{
    sponserId:{ writable: true, configurable: false, enumerable: true},
    sponserName: { writable: true, configurable: false, enumerable: true}
})

GentleServiceHelp.help = function(json){
    const component =  Object.create(this);
    const me = json.me;
    const type = json.helpType;

    const render = function(type){        
        // 봇버블
        {
            var bubble = Object.create( GentleComponentBubble );   
            bubble.createComponent({
                    "html": GentleLang.translate(GentleLang.type.HelpBot, me),
            });     
            bubble.insert();     
        }

        // 캐릭터 카드
        {
            let title = '';
            let comment = ''
            switch (type) {
                case '1':
                    title = GentleLang.translate(GentleLang.type.HelpTitleMenu);
                    comment = GentleLang.translate(GentleLang.type.HelpCommentMenu);
                    break;
                case '2':
                    title = GentleLang.translate(GentleLang.type.HelpTitleInvite);
                    comment = GentleLang.translate(GentleLang.type.HelpCommentInvite);
                    break;
                case '3':
                    title = GentleLang.translate(GentleLang.type.HelpTitlePlan);
                    comment = GentleLang.translate(GentleLang.type.HelpCommentPlan);
                    break;
                case '4':
                    title = GentleLang.translate(GentleLang.type.HelpTitleProfile);
                    comment = GentleLang.translate(GentleLang.type.HelpCommentProfile);
                    break;
                default:
                    break;
            }
            const html = `<div style="border:solid 1px red">\
            <div>${title}</div>\
            <div>${comment}</div>\
            </div>`;

            component.insertElement($(html));
        }

        // 인기상품버튼
        {
            let text = '';
            switch (type) {
                case '1':
                    text = GentleLang.translate(GentleLang.type.HelpButtonMenu);
                    break;
                case '2':
                    text = GentleLang.translate(GentleLang.type.HelpButtonInvite);
                    break;
                case '3':
                    text = GentleLang.translate(GentleLang.type.HelpButtonPlan);
                    break;
                case '4':
                    text = GentleLang.translate(GentleLang.type.HelpButtonProfile);
                    break;
                default:
                    break;
            }

            const handler = function(){
                console.log(text);
            };
        
            const option = [
                {
                    text: text,
                    user: 'user',
                    onClick: handler,
                },
            ]
            var button = Object.create( GentleComponentButton);
            button.createComponent(option);
            button.insert();
        }
    };

    render(type);
}

export default GentleServiceHelp;